import { render, staticRenderFns } from "./PlayerProfileLink.vue?vue&type=template&id=8c850f3a"
import script from "./PlayerProfileLink.js?vue&type=script&lang=js&external"
export * from "./PlayerProfileLink.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports